import { InjectionToken } from '@angular/core';
import { InputTemplateService } from './core-input.def';

export const IINPUT_TEMPLATE_SERVICE = new InjectionToken<InputTemplateService>(
  'IINPUT_TEMPLATE_SERVICE'
);
